module.exports = __webpack_public_path__ + "static/media/game-sum_icon.1f2e41d3.svg";